module.exports = __webpack_public_path__ + "img/plan1.00ae472.webp";